const REDACTED_KEYWORDS = ['apikey', 'accesstoken', 'Authorization', 'secret'].map(k => k.toLowerCase());
const REDACTED_VALUE = '[REDACTED]';

const defaultOptions: RedactionOptions = { disableRedaction: false };

const redact = (info: any, options: RedactionOptions = defaultOptions): any => {
  if (options.disableRedaction) return info;

  const redactionKeyWords = options.keyWords ? REDACTED_KEYWORDS.concat(options.keyWords) : REDACTED_KEYWORDS;
  if (typeof info !== 'object') {
    return info;
  } else if (Array.isArray(info)) {
    // Redact each value of the array.
    return info.map(val => redact(val, options));
  } else {
    return Object.keys(info).reduce(
      (acc, key) => {
        if (isKeyWordMatch(key, redactionKeyWords)) {
          acc[key] = options.redactedValue || REDACTED_VALUE;
        } else {
          acc[key] = info[key] ? redact(info[key], options) : info[key];
        }
        return acc;
      },
      {} as Record<string, any>,
    );
  }
};

export interface RedactionOptions {
  disableRedaction?: boolean;
  keyWords?: Array<string>;
  redactedValue?: string;
}

const isKeyWordMatch = (key: string, keywords?: Array<string>) =>
  keywords?.map(k => k.toLowerCase()).includes(key.toLowerCase()) ?? false;
export default redact;
